// extracted by mini-css-extract-plugin
var _1 = "arms-highlighted__bgibQ";
var _2 = "bodypart-selector__K1Opq";
var _3 = "head-highlighted__UWVkd";
var _4 = "label__zd7UL";
var _5 = "legs-highlighted__fii4a";
var _6 = "lung-highlighted__KzkCt";
var _7 = "torso-highlighted___Vis4";
var _8 = "visual__TZW1X";
export { _1 as "arms-highlighted", _2 as "bodypart-selector", _3 as "head-highlighted", _4 as "label", _5 as "legs-highlighted", _6 as "lung-highlighted", _7 as "torso-highlighted", _8 as "visual" }
